import { render } from "./Menu.vue?vue&type=template&id=6eb280c2&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=6eb280c2&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=6eb280c2&lang=scss&scoped=true"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb280c2"]])

export default __exports__